import { render, staticRenderFns } from "./itemcaracteristica-form.vue?vue&type=template&id=0b2186d2&scoped=true"
import script from "./itemcaracteristica-form.vue?vue&type=script&lang=js"
export * from "./itemcaracteristica-form.vue?vue&type=script&lang=js"
import style0 from "./itemcaracteristica-form.vue?vue&type=style&index=0&id=0b2186d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2186d2",
  null
  
)

export default component.exports